import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { onMount, waitFor } from 'lp-hoc'
import * as apiActions from 'api-actions'
import { selectors as globalSelectors } from './reducer'

const propTypes = {
  children: PropTypes.node.isRequired,
}

const defaultProps = {}

function GlobalLayout({ children }) {
  return <React.Fragment>{children}</React.Fragment>
}

GlobalLayout.propTypes = propTypes
GlobalLayout.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    disciplines: globalSelectors.disciplines(state),
    resourceTypes: globalSelectors.resourceTypes(state),
    schoolYears: globalSelectors.schoolYears(state),
    programTypes: globalSelectors.orderedProgramTypes(state),
    languages: globalSelectors.languages(state),
    outcomeTypes: globalSelectors.outcomeTypes(state),
    approaches: globalSelectors.approaches(state),
    demographics: globalSelectors.demographics(state),
    badgeQuestions: globalSelectors.badgeQuestions(state),
  }
}

const mapDispatchToProps = {
  fetchDisciplines: apiActions.fetchDisciplines,
  fetchResourceTypes: apiActions.fetchResourceTypes,
  fetchSchoolYears: apiActions.fetchSchoolYears,
  fetchProgramTypes: apiActions.fetchProgramTypes,
  fetchLanguages: apiActions.fetchLanguages,
  fetchOutcomeTypes: apiActions.fetchOutcomeTypes,
  fetchApproaches: apiActions.fetchApproaches,
  fetchDemographics: apiActions.fetchDemographics,
  fetchBadgeQuestions: apiActions.fetchBadgeQuestions,
}

function safeFetch(fetch) {
  return Promise.resolve(fetch()).catch(() => {})
}

const fetchAppWideData = ({
  fetchDisciplines,
  fetchResourceTypes,
  fetchSchoolYears,
  fetchProgramTypes,
  fetchLanguages,
  fetchOutcomeTypes,
  fetchApproaches,
  fetchDemographics,
  fetchBadgeQuestions,
}) => {
  safeFetch(fetchDisciplines)
  safeFetch(fetchResourceTypes)
  safeFetch(fetchSchoolYears)
  safeFetch(fetchProgramTypes)
  safeFetch(fetchLanguages)
  safeFetch(fetchOutcomeTypes)
  safeFetch(fetchApproaches)
  safeFetch(fetchDemographics)
  safeFetch(fetchBadgeQuestions)
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  onMount(fetchAppWideData),
  waitFor([
    'approaches',
    'disciplines',
    'languages',
    'resourceTypes',
    'schoolYears',
    'programTypes',
    'outcomeTypes',
    'demographics',
    'badgeQuestions',
  ])
)(GlobalLayout)
